export const ERROR_NO_CLIENT_PANEL_GROUP = "NO_CLIENT_PANEL_GROUP";
